"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EContentType = void 0;
const EnumObject_1 = require("../../../../core/domain/EnumObject");
const enumValues = {
    JSON: "application/json",
    OCTET_STREAM: "application/octet-stream",
    MODEL_USD: "model/usd",
    MODEL_VND_USDZ_ZIP: "model/vnd.usdz+zip",
    VND_API_JSON: "application/vnd.api+json",
    AUDIO_OGG: "audio/ogg",
    IMAGE_JPEG: "image/jpeg",
    IMAGE_PNG: "image/png",
};
class EContentType extends EnumObject_1.EnumObject {
    constructor(value) {
        super(value);
    }
    static create(p) {
        return new EContentType(p);
    }
}
exports.EContentType = EContentType;
EContentType.V = enumValues;
//# sourceMappingURL=EContentType.js.map